var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAssignGoods.table.price"),
                prop: "logisticCompanyId",
              },
            },
            [
              _c("BjSelectLogisticCompany", {
                attrs: {
                  value: _vm.form.logisticCompanyId,
                  "default-options": {
                    label: _vm.form.logisticCompanyName,
                    value: _vm.form.logisticCompanyId,
                  },
                },
                on: { change: _vm.onLogistic },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingAssignGoods.addAndEdit.business"),
                prop: "logisticBusinessId",
              },
            },
            [
              _c("BjSelectLogisticBusiness", {
                attrs: {
                  value: _vm.form.logisticBusinessId,
                  disabled: !_vm.form.logisticCompanyId,
                  "default-params": _vm.defaultParams,
                  "default-options": {
                    label: _vm.form.logisticBusinessName,
                    value: _vm.form.logisticBusinessId,
                  },
                  placeholder: _vm.form.logisticCompanyId
                    ? _vm.$t("chooseText")
                    : _vm.$t("settingAssignGoods.addAndEdit.logisticsText"),
                },
                on: { change: _vm.onBusiness },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          config: _vm.$BjDialogListConfig.spuDefault(),
          "row-keys": "spuCode",
        },
        on: { confirm: _vm.onConfirmDialogList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }